import { Star } from "@/components/icons";
import { G2_COLOR, TRUSTPILOT_COLOR } from "@/lib/constants";

const PLATFORM_STAR_COLORS: Record<string, string> = {
  G2: G2_COLOR,
  Trustpilot: TRUSTPILOT_COLOR,
};

interface StarRatingProps {
  rating?: number;
  platform?: string;
  color?: string;
  size?: number;
}

export function StarRating({ rating = 5, platform, color, size = 14 }: StarRatingProps) {
  const fillColor = color ?? (platform ? (PLATFORM_STAR_COLORS[platform] ?? "#f59e0b") : "#f59e0b");

  return (
    <div className="flex gap-0.5" role="img" aria-label={`${rating} out of 5 stars`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const fillAmount = Math.max(0, Math.min(1, rating - i));
        return (
          <span
            key={i}
            className="relative inline-flex"
            style={{ width: size, height: size }}
            aria-hidden="true"
          >
            <Star size={size} className="text-muted-foreground/20" aria-hidden="true" />
            {fillAmount > 0 && (
              <Star
                size={size}
                className="absolute inset-0"
                style={{
                  fill: fillColor,
                  color: fillColor,
                  clipPath: `inset(0 ${100 - fillAmount * 100}% 0 0)`,
                }}
                aria-hidden="true"
              />
            )}
          </span>
        );
      })}
    </div>
  );
}
